import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, Card, CardContent, ListItemText, Avatar, IconButton } from '@mui/material';

import TwitterIcon from '@mui/icons-material/Twitter';
import GitHubIcon from '@mui/icons-material/GitHub';
import FacebookIcon from '@mui/icons-material/Facebook';

import { SimTypography } from 'components/SimTypography';

const teamDetails = [
	{
		name: 'Dr. Erica Jowett-Hirst, Advisor',
		title: 'BCBA – Functional Behavior Expert',
		avatar: 'https://media.licdn.com/dms/image/C5603AQFtRlf5piSd2Q/profile-displayphoto-shrink_800_800/0/1557411861384?e=2147483647&v=beta&t=wb6mfuaIlngseWo_iWJloztlgjoBiFGwCJTdhOK43dc',
		about: 'Dr. Erica brings experience in ABA therapy of 20+ years, and studies visible, permanent beahvioral changes.'
	},
	{
		name: 'Bill Creamer, Advisor',
		title: 'Founder@Lockton | Insurance',
		avatar: 'https://media.licdn.com/dms/image/C4E03AQE6uzJONYVYdw/profile-displayphoto-shrink_800_800/0/1552687326151?e=1680739200&v=beta&t=QjswGWP_EL62uHDEIKAAMfwypmtwVsuNM2mebb4S-vw',
		about: 'Bill specializes in handling insurance processes for the  full spectrum of care and treatment for special needs children.'
	},
	{
		name: 'Dipika Cherala, Advisor',
		title: 'Speech Language Pathologist',
		avatar: '',
		about: 'Dipika brings 15+ years of experience practicing and teaching speech, language and communication disorders.'
	},
	{
		name: 'Dr. Vasan Purighalla, Advisor',
		title: 'Neurosurgeon',
		avatar: 'https://i2.ypcdn.com/blob/bad80c2134bedb66568244203e1eccb965d119cd',
		about: 'Dr. Vasan is a pioneer in neuro research, and studies the impact of non-verbal therapies on cognitive flexibility.'
	},
	{
		name: 'Dr. Zulfikar Mohammad, Advisor',
		title: 'Pediatrician',
		avatar: '',
		about: 'Dr. Zulfi is a pediatrician for 20+ years with expertise in early childhood development.'
	},
	{
		name: 'Dr. Praveen Kumar, Advisor',
		title: 'Pediatrician',
		avatar: '',
		about: 'Dr. Kumar is a seasoned pediatrician with 17+ years of experience who is passionate about child development.'
	}
];

const Team = () => {
	const theme = useTheme();
	return (
		<Box>
			<Grid container spacing={2}>
				{teamDetails.map((item, i) => (
					<Grid item xs={12} sm={6} md={4} key={i}>
						<Box
							component={Card}
							minHeight={350}
							boxShadow={3}
							sx={{
								textDecoration: 'none',
								transition: 'all .2s ease-in-out',
								'&:hover': {
									transform: `translateY(-${theme.spacing(1 / 2)})`
								}
							}}>
							<CardContent>
								<Box component={Avatar} src={item.avatar} height={80} width={80} />
								<Box marginTop={4}>
									<ListItemText primary={item.name} secondary={item.title} />
									<SimTypography variant={'subtitle2'} color={'text.secondary'}>
										{item.about}
									</SimTypography>
									<Box marginTop={4}>
										<IconButton size={'small'} color={'primary'}>
											<FacebookIcon />
										</IconButton>
										<IconButton size={'small'} color={'primary'}>
											<GitHubIcon />
										</IconButton>
										<IconButton size={'small'} color={'primary'}>
											<TwitterIcon />
										</IconButton>
									</Box>
								</Box>
							</CardContent>
						</Box>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default Team;
